import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Detalii generale ", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "payment-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "payment-tag-content" }, "Nume medic:", -1)
const _hoisted_5 = { class: "payment-value-content" }
const _hoisted_6 = { class: "payment-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "payment-tag-content" }, "Telefon:", -1)
const _hoisted_8 = { class: "payment-value-content" }
const _hoisted_9 = { class: "payment-container" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "payment-tag-content" }, "Email:", -1)
const _hoisted_11 = { class: "payment-value-content" }
const _hoisted_12 = { class: "payment-container" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "payment-tag-content" }, "Entitate comerciala:", -1)
const _hoisted_14 = { class: "payment-value-content" }
const _hoisted_15 = { class: "payment-container" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "payment-tag-content" }, "CUI:", -1)
const _hoisted_17 = { class: "payment-value-content" }
const _hoisted_18 = { class: "payment-container" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "payment-tag-content" }, "IBAN:", -1)
const _hoisted_20 = { class: "payment-value-content" }
const _hoisted_21 = { class: "payment-container" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "payment-tag-content" }, "Judet:", -1)
const _hoisted_23 = { class: "payment-value-content" }
const _hoisted_24 = { class: "payment-container" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "payment-tag-content" }, "Localitate:", -1)
const _hoisted_26 = { class: "payment-value-content" }
const _hoisted_27 = { class: "payment-container" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "payment-tag-content" }, "Adresa:", -1)
const _hoisted_29 = { class: "payment-value-content" }
const _hoisted_30 = { class: "payment-container" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "payment-tag-content" }, "Serie factura:", -1)
const _hoisted_32 = { class: "payment-value-content" }
const _hoisted_33 = { class: "payment-container" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "payment-tag-content" }, "Regula decontare:", -1)
const _hoisted_35 = { class: "payment-value-content" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }

import { useRoute } from 'vue-router';
import { inject, onMounted, ref, Ref } from 'vue';
import { Doctor } from '@/interfaces/Doctor';
import { DoctorConfig } from '@/interfaces/DoctorConfig';
import { MoneyUtils } from '@/utils/MoneyUtils';
import { DoctorEntityServiceCtx } from '@/api';
import { DoctorEntity } from '@/interfaces/DoctorEntity';
import DoctorService from '@/services/DoctorService';
import DoctorEntityService from '@/services/DoctorEntityService';
import Card from 'primevue/card';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorEntity',
  setup(__props) {

const doctorEntityService: DoctorEntityService | undefined = inject(
  DoctorEntityServiceCtx
);

const route = useRoute();
const doctorId = route.params.id as string;
const doctor: Ref<Doctor | null> = ref(null as Doctor | null);
const doctorConfig: Ref<DoctorConfig | null> = ref(null as DoctorConfig | null);
const doctorEntity: Ref<DoctorEntity | null> = ref(null as DoctorEntity | null);
const loading = ref(true);

onMounted(async () => {
  const fetchedDoctor = await DoctorService.fetchDoctor(doctorId);
  if (fetchedDoctor) {
    doctor.value = fetchedDoctor;
  }
  const fetchedConfig = await DoctorService.fetchDoctorConfig(doctorId);
  if (fetchedConfig) {
    fetchedConfig.commissionPercent = fetchedConfig.commissionPercent * 100;
    doctorConfig.value = fetchedConfig;
  }
  const fetchedEntity = await doctorEntityService?.fetchDoctorEntity(doctorId);
  if (fetchedEntity) {
    doctorEntity.value = fetchedEntity;
  }
});

const safeDisplay = (value: string): string => value || '';

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createVNode(_unref(Card), null, {
      title: _withCtx(() => [
        _createTextVNode(" Decontare medic ")
      ]),
      subtitle: _withCtx(() => [
        _hoisted_1
      ]),
      content: _withCtx(() => [
        (doctor.value?.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(safeDisplay(doctor.value.firstName) + ' ' + safeDisplay(doctor.value.lastName)), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(doctor.value?.phoneNo), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(doctor.value?.email), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(doctorEntity.value?.entityName), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(doctorEntity.value?.entityCui), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, _toDisplayString(doctorEntity.value?.entityIban), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(doctorEntity.value?.entityCounty), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, _toDisplayString(doctorEntity.value?.entityCity), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, _toDisplayString(doctorEntity.value?.entityStreet), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, _toDisplayString(doctorEntity.value?.invoiceSerial! + doctorEntity.value?.invoiceCurrentNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  (doctorConfig.value?.payoutDaysInterval)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(doctorConfig.value?.payoutDaysInterval) + " zile", 1))
                    : _createCommentVNode("", true),
                  (doctorConfig.value?.payoutMoneyLimit)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_unref(MoneyUtils).formatd(doctorConfig.value?.payoutMoneyLimit)) + " lei ", 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})